(function () {
  'use strict';

  angular.module('datamatic', []);
})();
